import { inject, Injectable } from '@angular/core';
import { DataLayerTypeStore } from '../../stores/data-layer-type/data-layer-type.state';
import { DataLayerType } from '../../models/data-layer-type';
import { IndicatorDataStore } from '../../stores/indicatpr-data/indicator-data.state';

@Injectable({
  providedIn: 'root',
})
export class DataHelperService {
  readonly layerTypeStore = inject(DataLayerTypeStore);
  readonly dataStore = inject(IndicatorDataStore);

  /**
   * Retrieves the list of data layer types that have associated data for the specified indicators.
   *
   * @param {string[]} indicatorsIds - An array of indicator IDs to check for associated data.
   * @return {DataLayerType[]} An array of data layer types that have data in the provided indicators.
   */
  availableDataLayerTypesWithDataInIndicators(
    indicatorsIds: string[]
  ): DataLayerType[] {
    const types = this.layerTypeStore.asArray();
    return types.filter(type =>
      this.dataStore.dataLayerTypeAndIndicatorsHasData(
        type._id,
        indicatorsIds,
        true
      )
    );
  }

  /**
   * Retrieves the first available data layer type that contains data in the specified indicators.
   *
   * @param {string[]} indicatorsIds - An array of indicator IDs to check for data presence.
   * @return {DataLayerType} The first available data layer type containing data in the given indicators.
   */
  firstAvailableDataLayerTypeWithDataInIndicators(
    indicatorsIds: string[]
  ): DataLayerType {
    return this.availableDataLayerTypesWithDataInIndicators(indicatorsIds)[0];
  }
}
